(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
// Homepage Featured collection: fetch all pages, sort, then apply products_to_show.
// Registration also supports sections reloaded by the theme editor.
if (!customElements.get('dawn-stock-sorted-featured')) {
  customElements.define('dawn-stock-sorted-featured', class extends HTMLElement {
    connectedCallback() {
      // Facet HTML can connect before its descendants have finished parsing.
      queueMicrotask(() => {
        if (this.isConnected && !this.started) this.sortCollection();
      });
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.started = false;
    }

    async sortCollection() {
      const grid = this.querySelector('[data-featured-stock-grid]');
      const meta = this.querySelector('[data-featured-stock-meta]');
      if (!grid || !meta || !grid.matches('ul')) return;
      this.started = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const status = this.querySelector('[data-stock-sort-status]');
      const pagination = this.querySelector('.slider-buttons');
      const pageCount = Number(meta.dataset.pages);
      const currentPage = Number(meta.dataset.page);
      const pageSize = Number(this.dataset.limit);
      const expectedCount = Number(meta.dataset.productCount);
      const baseURL = new URL(window.location.href);
      baseURL.searchParams.delete('sections');
      baseURL.searchParams.delete('section_id');
      this.setAttribute('aria-busy', 'true');
      grid.style.visibility = 'hidden';
      if (pagination) pagination.style.visibility = 'hidden';
      if (status) status.hidden = false;

      const cardsFrom = root => Array.from(root.querySelectorAll('[data-featured-stock-grid] > li[data-stock-product-id]'));
      const pages = new Map([[currentPage, cardsFrom(this)]]);
      const pending = Array.from({ length: pageCount }, (_, i) => i + 1).filter(p => p !== currentPage);

      try {
        if (!pageSize || !pageCount || currentPage < 1 || currentPage > pageCount) {
          throw new Error('Invalid collection pagination.');
        }
        const fetchPage = async page => {
          const url = new URL(baseURL);
          url.searchParams.set(meta.dataset.pageParam || 'page', String(page));
          url.searchParams.set('section_id', this.dataset.sectionId);
          const timeout = setTimeout(() => this.controller.abort(), 30000);
          let html;
          try {
            const response = await fetch(url, { signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Could not load collection page ' + page);
            html = await response.text();
          } finally {
            clearTimeout(timeout);
          }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const root = Array.from(doc.querySelectorAll('dawn-stock-sorted-featured'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          const fetchedMeta = root && root.querySelector('[data-featured-stock-meta]');
          if (!root || root.dataset.collectionId !== this.dataset.collectionId || !fetchedMeta || Number(fetchedMeta.dataset.page) !== page ||
              Number(fetchedMeta.dataset.productCount) !== expectedCount ||
              Number(fetchedMeta.dataset.pages) !== pageCount) {
            throw new Error('The collection changed while loading. Please reload.');
          }
          pages.set(page, cardsFrom(root));
        };

        // Limit parallel requests; never assume the collection fits in one page.
        const worker = async () => {
          while (pending.length && !signal.aborted) await fetchPage(pending.shift());
        };
        await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
        if (!this.isConnected || signal.aborted) return;

        const cards = Array.from(pages.keys()).sort((a, b) => a - b).flatMap(page => pages.get(page));
        const uniqueIDs = new Set(cards.map(card => card.dataset.stockProductId));
        if (cards.length !== expectedCount || uniqueIDs.size !== expectedCount) {
          throw new Error('Could not load every product exactly once. Please reload.');
        }

        // Priority first, then newest creation date. Product ID breaks date ties.
        cards.sort((a, b) =>
          Number(a.dataset.stockRank) - Number(b.dataset.stockRank) ||
          Number(b.dataset.stockCreated) - Number(a.dataset.stockCreated) ||
          a.dataset.stockProductId.localeCompare(b.dataset.stockProductId)
        );
        // The homepage always shows the first N products AFTER full sorting.
        const visibleCards = cards.slice(0, pageSize).map((card, index) => {
          // Import fresh nodes so Dawn custom elements initialise in this document.
          const node = document.importNode(card, true);
          // Native page-local slide IDs repeat across pages; make them unique.
          node.id = 'Slide-' + this.dataset.sectionId + '-' + (index + 1);
          // Newly inserted cards must not remain hidden by Dawn's initial observer.
          node.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          node.removeAttribute('data-cascade');
          node.style.removeProperty('--animation-order');
          return node;
        });
        // Some Dawn card snippets include shared CSS in the first native card.
        // Keep those styles even when that card belongs on another sorted page.
        for (const link of grid.querySelectorAll('link[rel="stylesheet"]')) {
          if (!Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).some(existing => existing.href === link.href)) {
            document.head.appendChild(link.cloneNode(true));
          }
        }
        grid.replaceChildren(...visibleCards);
        grid.scrollLeft = 0;
        // Rebuild Dawn's cached slide list after replacing the cards.
        const slider = this.querySelector('slider-component');
        if (slider && typeof slider.resetPages === 'function') slider.resetPages();
        this.dataset.ready = 'true';
        if (status) status.hidden = true;
      } catch (error) {
        this.controller.abort();
        if (!this.isConnected) return;
        if (status) {
          status.textContent = this.dataset.errorMessage || 'Could not finish sorting products. Please reload this page.';
          status.hidden = false;
        }
        console.error('[Featured collection stock sorting]', error);
      } finally {
        if (this.isConnected) {
          grid.style.removeProperty('visibility');
          if (pagination) pagination.style.removeProperty('visibility');
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
// Registered once by Shopify's section JavaScript bundle. Reconnects after Dawn
// replaces ProductGridContainer during filtering, sorting, and browser history.
if (!customElements.get('dawn-stock-sorted-collection')) {
  customElements.define('dawn-stock-sorted-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enabled !== 'true') return;
      // Facet HTML can connect before its descendants have finished parsing.
      queueMicrotask(() => {
        if (this.isConnected && !this.started) this.sortCollection();
      });
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.started = false;
    }

    async sortCollection() {
      const grid = this.querySelector('#product-grid');
      if (!grid || !grid.matches('ul')) return;
      this.started = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const status = this.querySelector('[data-stock-sort-status]');
      const pagination = this.querySelector('.pagination-wrapper');
      const pageCount = Number(this.dataset.pages);
      const currentPage = Number(this.dataset.page);
      const pageSize = Number(this.dataset.pageSize);
      const expectedCount = Number(this.dataset.productCount);
      const baseURL = new URL(window.location.href);
      baseURL.searchParams.delete('sections');
      baseURL.searchParams.delete('section_id');
      this.setAttribute('aria-busy', 'true');
      grid.style.visibility = 'hidden';
      if (pagination) pagination.style.visibility = 'hidden';
      if (status) status.hidden = false;

      const cardsFrom = root => Array.from(root.querySelectorAll('#product-grid > li[data-stock-product-id]'));
      const pages = new Map([[currentPage, cardsFrom(this)]]);
      const pending = Array.from({ length: pageCount }, (_, i) => i + 1).filter(p => p !== currentPage);

      try {
        if (!pageSize || !pageCount || currentPage < 1 || currentPage > pageCount) {
          throw new Error('Invalid collection pagination.');
        }
        const fetchPage = async page => {
          const url = new URL(baseURL);
          url.searchParams.set(this.dataset.pageParam || 'page', String(page));
          url.searchParams.set('section_id', this.dataset.sectionId);
          const timeout = setTimeout(() => this.controller.abort(), 30000);
          let html;
          try {
            const response = await fetch(url, { signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Could not load collection page ' + page);
            html = await response.text();
          } finally {
            clearTimeout(timeout);
          }
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const root = Array.from(doc.querySelectorAll('dawn-stock-sorted-collection'))
            .find(element => element.dataset.sectionId === this.dataset.sectionId);
          if (!root || Number(root.dataset.page) !== page ||
              Number(root.dataset.productCount) !== expectedCount ||
              Number(root.dataset.pages) !== pageCount) {
            throw new Error('The collection changed while loading. Please reload.');
          }
          pages.set(page, cardsFrom(root));
        };

        // Limit parallel requests; never assume the collection fits in one page.
        const worker = async () => {
          while (pending.length && !signal.aborted) await fetchPage(pending.shift());
        };
        await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
        if (!this.isConnected || signal.aborted) return;

        const cards = Array.from(pages.keys()).sort((a, b) => a - b).flatMap(page => pages.get(page));
        const uniqueIDs = new Set(cards.map(card => card.dataset.stockProductId));
        if (cards.length !== expectedCount || uniqueIDs.size !== expectedCount) {
          throw new Error('Could not load every product exactly once. Please reload.');
        }

        // Priority first, then newest creation date. Product ID breaks date ties.
        cards.sort((a, b) =>
          Number(a.dataset.stockRank) - Number(b.dataset.stockRank) ||
          Number(b.dataset.stockCreated) - Number(a.dataset.stockCreated) ||
          a.dataset.stockProductId.localeCompare(b.dataset.stockProductId)
        );
        const offset = (currentPage - 1) * pageSize;
        const visibleCards = cards.slice(offset, offset + pageSize).map(card => {
          // Import fresh nodes so Dawn custom elements initialise in this document.
          const node = document.importNode(card, true);
          // Newly inserted cards must not remain hidden by Dawn's initial observer.
          node.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          node.removeAttribute('data-cascade');
          node.style.removeProperty('--animation-order');
          return node;
        });
        // Some Dawn card snippets include shared CSS in the first native card.
        // Keep those styles even when that card belongs on another sorted page.
        for (const link of grid.querySelectorAll('link[rel="stylesheet"]')) {
          if (!Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).some(existing => existing.href === link.href)) {
            document.head.appendChild(link.cloneNode(true));
          }
        }
        grid.replaceChildren(...visibleCards);
        this.dataset.ready = 'true';
        if (status) status.hidden = true;
      } catch (error) {
        this.controller.abort();
        if (!this.isConnected) return;
        if (status) {
          status.textContent = this.dataset.errorMessage || 'Could not finish sorting products. Please reload this page.';
          status.hidden = false;
        }
        console.error('[Collection stock sorting]', error);
      } finally {
        if (this.isConnected) {
          grid.style.removeProperty('visibility');
          if (pagination) pagination.style.removeProperty('visibility');
          this.removeAttribute('aria-busy');
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
